import React from 'react';
import { Switch, Route } from 'react-router-dom';
import WaitingList from '../../pages/waitingList/list/list.js';
import WaitingListSubscribersList from '../../pages/waitingList/subscribers/list.js';
import PageError from '../../pages/error/pageError';
import { ManagerContextProvider } from '../../pages/manager/components/context';

export default function WaitingListEventRouter({ organization, event, path }) {
    return (
        <ManagerContextProvider>
            <Switch>
                <Route
                    exact
                    path={[`${path}/`, `${path}`]}
                    render={({ match, history }) => {
                        return <WaitingList organization={organization} event={event} />;
                    }}
                />
                <Route
                    exact
                    path={`${path}/:waitingListId/subscribers`}
                    render={({ match, history }) => {
                        return <WaitingListSubscribersList organization={organization} event={event} waitingListId={match.params.waitingListId} />;
                    }}
                />
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
            </Switch>
        </ManagerContextProvider>
    );
}
